import { render, staticRenderFns } from "./AddPricingPackage.vue?vue&type=template&id=c499b65a"
import script from "./AddPricingPackage.vue?vue&type=script&lang=js"
export * from "./AddPricingPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports